// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export var Source;
(function (Source) {
    Source["UNKNOWN"] = "UNKNOWN";
    Source["ONLINE"] = "ONLINE";
})(Source || (Source = {}));
export var Source_index;
(function (Source_index) {
    Source_index[Source_index["UNKNOWN"] = 0] = "UNKNOWN";
    Source_index[Source_index["ONLINE"] = 1] = "ONLINE";
})(Source_index || (Source_index = {}));
export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWNSTATUS"] = "UNKNOWNSTATUS";
    RequestStatus["PENDING"] = "PENDING";
    RequestStatus["ACCEPTED"] = "ACCEPTED";
    RequestStatus["REJECTED"] = "REJECTED";
})(RequestStatus || (RequestStatus = {}));
export var RequestStatus_index;
(function (RequestStatus_index) {
    RequestStatus_index[RequestStatus_index["UNKNOWNSTATUS"] = 0] = "UNKNOWNSTATUS";
    RequestStatus_index[RequestStatus_index["PENDING"] = 1] = "PENDING";
    RequestStatus_index[RequestStatus_index["ACCEPTED"] = 2] = "ACCEPTED";
    RequestStatus_index[RequestStatus_index["REJECTED"] = 3] = "REJECTED";
})(RequestStatus_index || (RequestStatus_index = {}));
export const ScheduleAPI = {
    ListNonrecurringEvents(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-events?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetNonrecurringEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringEventId"], "nonrecurringEventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-events/${req["nonrecurringEventId"]}?${fm.renderURLSearchParams(req, ["nonrecurringEventId"])}`, { method: "GET" });
    },
    CreateNonrecurringEvent(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-events`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateNonrecurringEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringEventId"], "nonrecurringEventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-events/${req["nonrecurringEventId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteNonrecurringEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringEventId"], "nonrecurringEventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-events/${req["nonrecurringEventId"]}?${fm.renderURLSearchParams(req, ["nonrecurringEventId"])}`, { method: "DELETE" });
    },
    /**
     *  will create or update multiple nonrecurring events at once, and requires an eventID be supplied for each event to enforce idempotence.
     */
    UpsertBatchNonrecurringEvent(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-events`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- Pairing Restriction RPCs -----------------
     */
    ListNonrecurringPairingRestrictionEvents(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-pairing-restrictions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetNonrecurringPairingRestrictionEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringPairingRestrictionId"], "nonrecurringPairingRestrictionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-pairing-restrictions/${req["nonrecurringPairingRestrictionId"]}?${fm.renderURLSearchParams(req, ["nonrecurringPairingRestrictionId"])}`, { method: "GET" });
    },
    CreateNonrecurringPairingRestrictionEvent(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-pairing-restrictions`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateNonrecurringPairingRestrictionEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringPairingRestrictionId"], "nonrecurringPairingRestrictionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-pairing-restrictions/${req["nonrecurringPairingRestrictionId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteNonrecurringPairingRestrictionEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringPairingRestrictionId"], "nonrecurringPairingRestrictionId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-pairing-restrictions/${req["nonrecurringPairingRestrictionId"]}?${fm.renderURLSearchParams(req, ["nonrecurringPairingRestrictionId"])}`, { method: "DELETE" });
    },
    /**
     *  will create or update multiple nonrecurring events at once, and requires an eventID be supplied for each event to enforce idempotence.
     */
    UpsertBatchNonrecurringPairingRestrictionEvent(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-pairing-restrictions`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- Availability Events RPCs -----------------
     */
    ListNonrecurringAvailabilityEvents(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-availability?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetNonrecurringAvailabilityEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringAvailabilityId"], "nonrecurringAvailabilityId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-availability/${req["nonrecurringAvailabilityId"]}?${fm.renderURLSearchParams(req, ["nonrecurringAvailabilityId"])}`, { method: "GET" });
    },
    CreateNonrecurringAvailabilityEvent(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-availability`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateNonrecurringAvailabilityEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringAvailabilityId"], "nonrecurringAvailabilityId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-availability/${req["nonrecurringAvailabilityId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteNonrecurringAvailabilityEvent(fn, req) {
        try {
            fm.validateUrlParam(req["nonrecurringAvailabilityId"], "nonrecurringAvailabilityId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/nonrecurring-availability/${req["nonrecurringAvailabilityId"]}?${fm.renderURLSearchParams(req, ["nonrecurringAvailabilityId"])}`, { method: "DELETE" });
    },
    /**
     *  will create or update multiple nonrecurring availability events at once, and requires an eventID be supplied for each event to enforce idempotence.
     */
    UpsertBatchNonrecurringAvailabilityEvent(fn, req) {
        return fn(`/schedule/api/v2/nonrecurring-availability`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- Recurring Event RPCs -----------------
     */
    ListRecurringEvents(fn, req) {
        return fn(`/schedule/api/v2/recurring-events?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetRecurringEvent(fn, req) {
        try {
            fm.validateUrlParam(req["recurringEventId"], "recurringEventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/recurring-events/${req["recurringEventId"]}?${fm.renderURLSearchParams(req, ["recurringEventId"])}`, { method: "GET" });
    },
    CreateRecurringEvent(fn, req) {
        return fn(`/schedule/api/v2/recurring-events`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateRecurringEvent(fn, req) {
        try {
            fm.validateUrlParam(req["recurringEventId"], "recurringEventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/recurring-events/${req["recurringEventId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteRecurringEvent(fn, req) {
        try {
            fm.validateUrlParam(req["recurringEventId"], "recurringEventId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/recurring-events/${req["recurringEventId"]}?${fm.renderURLSearchParams(req, ["recurringEventId"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- List Open Times RPCs -----------------
     */
    ListOfficeOpenTimes(fn, req) {
        return fn(`/schedule/api/v2/offices/open-times?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpsertBatchOfficeOpenTimes(fn, req) {
        return fn(`/schedule/api/v2/offices/open-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListProviderOpenTimes(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["providerId"]}/open-times?${fm.renderURLSearchParams(req, ["providerId"])}`, { method: "GET" });
    },
    UpsertBatchProviderOpenTimes(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["providerId"]}/open-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListWorkstationOpenTimes(fn, req) {
        try {
            fm.validateUrlParam(req["workstationId"], "workstationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["workstationId"]}/open-times?${fm.renderURLSearchParams(req, ["workstationId"])}`, { method: "GET" });
    },
    UpsertBatchWorkstationOpenTimes(fn, req) {
        try {
            fm.validateUrlParam(req["workstationId"], "workstationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["workstationId"]}/open-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- List By Filter Closed Times RPCs -----------------
     */
    ListClosedTimesWeekView(fn, req) {
        return fn(`/schedule/api/v2/closed-times?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListClosedTimesDayView(fn, req) {
        try {
            fm.validateUrlParam(req["dayOfWeek"], "dayOfWeek");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/days/${req["dayOfWeek"]}/closed-times?${fm.renderURLSearchParams(req, ["dayOfWeek"])}`, { method: "GET" });
    },
    /**
     * ----------------- Office Closed Times RPCs -----------------
     */
    GetOfficeClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/closed-times/${req["closedTimeId"]}?${fm.renderURLSearchParams(req, ["closedTimeId"])}`, { method: "GET" });
    },
    CreateOfficeClosedTime(fn, req) {
        return fn(`/schedule/api/v2/offices/closed-times`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListOfficeClosedTimes(fn, req) {
        return fn(`/schedule/api/v2/offices/closed-times?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpsertBatchOfficeClosedTimes(fn, req) {
        return fn(`/schedule/api/v2/offices/closed-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateOfficeClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/closed-times/${req["closedTimeId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteOfficeClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/closed-times/${req["closedTimeId"]}?${fm.renderURLSearchParams(req, ["closedTimeId"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- Provider Closed Times RPCs -----------------
     */
    GetProviderClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["providerId"]}/closed-times/${req["closedTimeId"]}?${fm.renderURLSearchParams(req, ["providerId", "closedTimeId"])}`, { method: "GET" });
    },
    CreateProviderClosedTime(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["closedTime"]) === null || _a === void 0 ? void 0 : _a["providerId"], "closedTime.providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${(_b = req["closedTime"]) === null || _b === void 0 ? void 0 : _b["providerId"]}/closed-times`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListProviderClosedTimes(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["providerId"]}/closed-times?${fm.renderURLSearchParams(req, ["providerId"])}`, { method: "GET" });
    },
    UpsertBatchProviderClosedTimes(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["providerId"]}/closed-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateProviderClosedTime(fn, req) {
        var _a, _b, _c, _d, _e, _f;
        try {
            fm.validateUrlParam((_a = req["closedTime"]) === null || _a === void 0 ? void 0 : _a["providerId"], "closedTime.providerId");
            fm.validateUrlParam((_c = (_b = req["closedTime"]) === null || _b === void 0 ? void 0 : _b["time"]) === null || _c === void 0 ? void 0 : _c["closedTimeId"], "closedTime.time.closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${(_d = req["closedTime"]) === null || _d === void 0 ? void 0 : _d["providerId"]}/closed-times/${(_f = (_e = req["closedTime"]) === null || _e === void 0 ? void 0 : _e["time"]) === null || _f === void 0 ? void 0 : _f["closedTimeId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteProviderClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["providerId"]}/closed-times/${req["closedTimeId"]}?${fm.renderURLSearchParams(req, ["providerId", "closedTimeId"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- Workstation Closed Times RPCs -----------------
     */
    GetWorkstationClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["workstationId"], "workstationId");
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["workstationId"]}/closed-times/${req["closedTimeId"]}?${fm.renderURLSearchParams(req, ["workstationId", "closedTimeId"])}`, { method: "GET" });
    },
    CreateWorkstationClosedTime(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["closedTime"]) === null || _a === void 0 ? void 0 : _a["workstationId"], "closedTime.workstationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${(_b = req["closedTime"]) === null || _b === void 0 ? void 0 : _b["workstationId"]}/closed-times`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    ListWorkstationClosedTimes(fn, req) {
        try {
            fm.validateUrlParam(req["workstationId"], "workstationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["workstationId"]}/closed-times?${fm.renderURLSearchParams(req, ["workstationId"])}`, { method: "GET" });
    },
    UpsertBatchWorkstationClosedTimes(fn, req) {
        try {
            fm.validateUrlParam(req["workstationId"], "workstationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["workstationId"]}/closed-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateWorkstationClosedTime(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["closedTime"]) === null || _a === void 0 ? void 0 : _a["workstationId"], "closedTime.workstationId");
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${(_b = req["closedTime"]) === null || _b === void 0 ? void 0 : _b["workstationId"]}/closed-times/${req["closedTimeId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteWorkstationClosedTime(fn, req) {
        try {
            fm.validateUrlParam(req["workstationId"], "workstationId");
            fm.validateUrlParam(req["closedTimeId"], "closedTimeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["workstationId"]}/closed-times/${req["closedTimeId"]}?${fm.renderURLSearchParams(req, ["workstationId", "closedTimeId"])}`, { method: "DELETE" });
    },
    UpsertBatchResourceClosedTimes(fn, req) {
        return fn(`/schedule/api/v2/closed-times`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListProviders(fn, req) {
        return fn(`/schedule/api/v2/providers?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListProvidersUnify(fn, req) {
        return fn(`/schedule/api/v2/providers-unify?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateProvider(fn, req) {
        return fn(`/schedule/api/v2/providers`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetProvider(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    UpdateProvider(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteProvider(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providers/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    GetProviderCountForLocations(fn, req) {
        return fn(`/schedule/api/v2/providers-count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- Office Hours RPCs -----------------
     */
    GetOfficeHours(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/officehours/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetOfficeHoursForMultipleLocations(fn, req) {
        return fn(`/schedule/api/v2/officehours?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateOfficeHours(fn, req) {
        return fn(`/schedule/api/v2/officehours`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateOfficeHours(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/officehours/${req["locationId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteOfficeHours(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/officehours/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "DELETE" });
    },
    GetProviderHours(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providerhours/${req["providerId"]}?${fm.renderURLSearchParams(req, ["providerId"])}`, { method: "GET" });
    },
    ListProvidersOfficeHoursByDayOfWeekForMultipleProviders(fn, req) {
        try {
            fm.validateUrlParam(req["dayOfWeek"], "dayOfWeek");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/days/${req["dayOfWeek"]}/provider-hours?${fm.renderURLSearchParams(req, ["dayOfWeek"])}`, { method: "GET" });
    },
    CreateProviderHours(fn, req) {
        return fn(`/schedule/api/v2/providerhours`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateProviderHours(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providerhours/${req["providerId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteProviderHours(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providerhours/${req["providerId"]}?${fm.renderURLSearchParams(req, ["providerId"])}`, { method: "DELETE" });
    },
    GetOfficeClosure(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/officeclosure/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    CreateOfficeClosure(fn, req) {
        return fn(`/schedule/api/v2/officeclosure`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteOfficeClosure(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/officeclosure/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "DELETE" });
    },
    GetProviderClosure(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providerclosure/${req["providerId"]}?${fm.renderURLSearchParams(req, ["providerId"])}`, { method: "GET" });
    },
    CreateProviderClosure(fn, req) {
        return fn(`/schedule/api/v2/providerclosure`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteProviderClosure(fn, req) {
        try {
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/providerclosure/${req["providerId"]}?${fm.renderURLSearchParams(req, ["providerId"])}`, { method: "DELETE" });
    },
    ListLocations(fn, req) {
        return fn(`/schedule/api/v2/locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetParentLocation(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/parentlocation/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    MigrateOfficeHours(fn, req) {
        return fn(`/schedule/api/v2/migrateofficehours?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpsertBatchProviders(fn, req) {
        return fn(`/schedule/api/v2/providers`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListWorkstations(fn, req) {
        return fn(`/schedule/api/v2/workstations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListWorkstationsUnify(fn, req) {
        return fn(`/schedule/api/v2/workstations-unify?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateWorkstation(fn, req) {
        return fn(`/schedule/api/v2/workstations`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetWorkstation(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    UpdateWorkstation(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteWorkstation(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/workstations/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    UpsertBatchWorkstations(fn, req) {
        return fn(`/schedule/api/v2/workstations`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ---------------- Web Assistant  ---------------------
     */
    GetWebAssistant(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/web-assistants/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    CreateWebAssistant(fn, req) {
        return fn(`/schedule/api/v2/web-assistants`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateWebAssistant(fn, req) {
        var _a, _b;
        try {
            fm.validateUrlParam((_a = req["webAssistant"]) === null || _a === void 0 ? void 0 : _a["id"], "webAssistant.id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/web-assistants/${(_b = req["webAssistant"]) === null || _b === void 0 ? void 0 : _b["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteWebAssistant(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/web-assistants/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    ListWebAssistants(fn, req) {
        return fn(`/schedule/api/v2/web-assistants?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListAppointmentTypeOpenings(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointment-types/${req["appointmentTypeId"]}/openings?${fm.renderURLSearchParams(req, ["appointmentTypeId"])}`, { method: "GET" });
    },
    ListAppointmentTypeTimes(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointment-types/${req["appointmentTypeId"]}/opening-times?${fm.renderURLSearchParams(req, ["appointmentTypeId"])}`, { method: "GET" });
    },
    /**
     * ----------------- Appointment Event RPCs -----------------
     */
    ListAppointments(fn, req) {
        return fn(`/schedule/api/v2/appointments?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetAppointment(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointments/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    CreateAppointment(fn, req) {
        return fn(`/schedule/api/v2/appointments`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateAppointment(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointments/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteAppointment(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointments/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    /**
     *  will create or update multiple appointments at once, and requires an Id be supplied for each event to enforce idempotence.
     */
    UpsertBatchAppointments(fn, req) {
        return fn(`/schedule/api/v2/appointments`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListAppointmentsTotal(fn, req) {
        return fn(`/schedule/api/v2/appointments-total?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- Integration Appointment Types -----------------
     *  will get a list of appointment types for a given location ID.
     */
    GetIntegrationAppointmentTypes(fn, req) {
        return fn(`/schedule/api/v2/integration-appointment-types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *  will create or replace multiple appointmentTypes at once.
     */
    UpsertIntegrationAppointmentTypes(fn, req) {
        return fn(`/schedule/api/v2/integration-appointment-types`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    ListActiveTimes(fn, req) {
        return fn(`/schedule/api/v2/active-times?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetActiveTime(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/active-times/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    CreateActiveTime(fn, req) {
        return fn(`/schedule/api/v2/active-times`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateActiveTime(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/active-times/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteActiveTime(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/active-times/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- Notes RPCs -----------------
     */
    ListNotes(fn, req) {
        return fn(`/schedule/api/v2/notes?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetNote(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/notes/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    CreateNote(fn, _req) {
        return fn(`/schedule/api/v2/notes`, { method: "POST" });
    },
    UpdateNote(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/notes/${req["id"]}`, { method: "PUT" });
    },
    DeleteNote(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/notes/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- Asset -----------------
     */
    Assets(fn, req) {
        return fn(`/schedule/api/v2/assets?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    UpdateAssets(fn, req) {
        return fn(`/schedule/api/v2/assets`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- Appointment Type -----------------
     */
    GetAppointmentTypeList(fn, req) {
        return fn(`/schedule/api/v2/appointment-types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    CreateAppointmentType(fn, req) {
        return fn(`/schedule/api/v2/appointment-types`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointment-types/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateAppointmentTypes(fn, req) {
        return fn(`/schedule/api/v2/appointment-types`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointment-types/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    GetAppointmentType(fn, req) {
        try {
            fm.validateUrlParam(req["appointmentTypeId"], "appointmentTypeId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/appointment-types/${req["appointmentTypeId"]}?${fm.renderURLSearchParams(req, ["appointmentTypeId"])}`, { method: "GET" });
    },
    GetAppointmentTypesCount(fn, req) {
        return fn(`/schedule/api/v2/appointment-types/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Add(fn, req) {
        return fn(`/schedule/api/v2/quickfill`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quickfill/${req["personId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    AutomatedUpdate(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quickfill/${req["personId"]}/automated-update`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    Remove(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quickfill/${req["personId"]}?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "DELETE" });
    },
    List(fn, req) {
        return fn(`/schedule/api/v2/quickfill?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Entry(fn, req) {
        try {
            fm.validateUrlParam(req["personId"], "personId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quickfill/${req["personId"]}?${fm.renderURLSearchParams(req, ["personId"])}`, { method: "GET" });
    },
    Count(fn, req) {
        return fn(`/schedule/api/v2/quickfill/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- Quickfill 2 -----------------
     */
    QuickfillList(fn, req) {
        return fn(`/schedule/api/v2/quick-fill?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    EntityStatusCreate(fn, req) {
        return fn(`/schedule/api/v2/quick-fill`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    EntityStatusUpdate(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    EntityStatusGet(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    EntityStatusDelete(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    CandidateStatusCreate(fn, req) {
        try {
            fm.validateUrlParam(req["entityId"], "entityId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["entityId"]}/candidate_status`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CandidateStatusUpdate(fn, req) {
        try {
            fm.validateUrlParam(req["entityId"], "entityId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["entityId"]}/candidate_status/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    CandidateStatusList(fn, req) {
        try {
            fm.validateUrlParam(req["entityId"], "entityId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["entityId"]}/candidate_status?${fm.renderURLSearchParams(req, ["entityId"])}`, { method: "GET" });
    },
    CandidateStatusGet(fn, req) {
        try {
            fm.validateUrlParam(req["entityId"], "entityId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["entityId"]}/candidate_status/${req["id"]}?${fm.renderURLSearchParams(req, ["entityId", "id"])}`, { method: "GET" });
    },
    CandidateStatusDelete(fn, req) {
        try {
            fm.validateUrlParam(req["entityId"], "entityId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/quick-fill/${req["entityId"]}/candidate_status/${req["id"]}?${fm.renderURLSearchParams(req, ["entityId", "id"])}`, { method: "DELETE" });
    },
    SendQuickFillMessage(fn, req) {
        return fn(`/schedule/api/v2/quick-fill/message/send`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetQuickFillMessageHistory(fn, req) {
        return fn(`/schedule/api/v2/quick-fill/message/history?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- SCHEDULE REQUEST -----------------
     */
    BookAppointment(fn, req) {
        return fn(`/schedule/api/v2/requests`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    BookScheduleLink(fn, req) {
        return fn(`/schedule/api/v2/requests/link`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetScheduleRequests(fn, req) {
        return fn(`/schedule/api/v2/requests?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetScheduleRequest(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/requests/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "GET" });
    },
    GetScheduleRequestHistory(fn, req) {
        return fn(`/schedule/api/v2/requests/history`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateScheduleRequest(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/requests/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteScheduleRequest(fn, req) {
        try {
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/requests/${req["id"]}?${fm.renderURLSearchParams(req, ["id"])}`, { method: "DELETE" });
    },
    GetScheduleRequestCount(fn, req) {
        return fn(`/schedule/api/v2/requests/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- SCHEDULE LINK -----------------
     */
    CreateScheduleLink(fn, req) {
        return fn(`/schedule/api/v2/request-links`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateScheduleLinkMeta(fn, req) {
        return fn(`/schedule/api/v2/request-links/meta?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetScheduleLink(fn, req) {
        try {
            fm.validateUrlParam(req["linkHash"], "linkHash");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/request-links/${req["linkHash"]}?${fm.renderURLSearchParams(req, ["linkHash"])}`, { method: "GET" });
    },
    /**
     * ----------------- Purge -----------------
     * This will purge all data related to location and source id
     */
    Purge(fn, req) {
        return fn(`/schedule/api/v2/purge`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- Calendar Exceptions -----------------
     */
    ListCalendarException(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/exceptions?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    ListCalendarExceptionForMultipleLocations(fn, req) {
        return fn(`/schedule/api/v2/offices/exceptions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarExceptionProvider(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/providers/${req["providerId"]}/exceptions?${fm.renderURLSearchParams(req, ["locationId", "providerId"])}`, { method: "GET" });
    },
    ListCalendarExceptionForMultipleProvidersOfMultiLocations(fn, req) {
        return fn(`/schedule/api/v2/offices/providers/exceptions?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListCalendarExceptionForMultipleProviders(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/providers/exceptions?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    GetCalendarException(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/exceptions/${req["id"]}?${fm.renderURLSearchParams(req, ["locationId", "id"])}`, { method: "GET" });
    },
    GetCalendarExceptionProvider(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["providerId"], "providerId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/providers/${req["providerId"]}/exceptions/${req["id"]}?${fm.renderURLSearchParams(req, ["locationId", "providerId", "id"])}`, { method: "GET" });
    },
    CreateCalendarException(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/exceptions`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    CreateCalendarExceptionProvider(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["providerId"], "providerId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/providers/${req["providerId"]}/exceptions`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendarException(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/exceptions/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCalendarExceptionProvider(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["providerId"], "providerId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/providers/${req["providerId"]}/exceptions/${req["id"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteCalendarException(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/exceptions/${req["id"]}?${fm.renderURLSearchParams(req, ["locationId", "id"])}`, { method: "DELETE" });
    },
    DeleteCalendarExceptionProvider(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["providerId"], "providerId");
            fm.validateUrlParam(req["id"], "id");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/offices/${req["locationId"]}/providers/${req["providerId"]}/exceptions/${req["id"]}?${fm.renderURLSearchParams(req, ["locationId", "providerId", "id"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- Custom Fields -----------------
     */
    CreateCustomFields(fn, req) {
        return fn(`/schedule/api/v2/customfields`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UpdateCustomFields(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/customfields/${req["locationId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetCustomFields(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/customfields/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    DeleteCustomFields(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/customfields/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "DELETE" });
    },
    /**
     * ----------------- Online Scheduling Report -----------------
     */
    GetOnlineSchedulingReportData(fn, req) {
        return fn(`/schedule/api/v2/online-scheduling-report?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- Unify -----------------
     */
    GetClientLocationIds(fn, req) {
        return fn(`/schedule/api/v2/client-locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- Customer -----------------
     */
    CreateCustomer(fn, req) {
        return fn(`/schedule/api/v2/customer`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ----------------- Health -----------------
     */
    GetOnlineSchedulingHealth(fn, req) {
        return fn(`/schedule/api/v2/health?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ----------------- Online Scheduling URL -----------------
     */
    GetOnlineSchedulingLink(fn, req) {
        return fn(`/schedule/api/v2/link?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     *Booking Email Request
     */
    PostBookingEmailRequest(fn, req) {
        return fn(`/schedule/api/v2/booking/email-request`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    KnownBookingEmail(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["patientId"], "patientId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/knownbooking/${req["locationId"]}/${req["patientId"]}?${fm.renderURLSearchParams(req, ["locationId", "patientId"])}`, { method: "GET" });
    },
    /**
     * Unknown Booking Email Request
     */
    UnknownBookingEmail(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
            fm.validateUrlParam(req["phoneNumber"], "phoneNumber");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/schedule/api/v2/unknownbooking/${req["locationId"]}/${req["phoneNumber"]}?${fm.renderURLSearchParams(req, ["locationId", "phoneNumber"])}`, { method: "GET" });
    },
    /**
     * -------------------------- Mass Messaging API's ---------------------------
     */
    MassMessageSend(fn, req) {
        return fn(`/schedule/api/v2/mass/send`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * -------------------------- Google Business Profile ---------------------------
     */
    SetGoogleBusinessProfileAppointmentLink(fn, req) {
        return fn(`/schedule/api/v2/google-business-profile-appointment-link`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetAllGoogleBusinessProfileAppointmentLinksDetails(fn, req) {
        return fn(`/schedule/api/v2/get-all-google-business-profile-appointment-links?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    DeleteGoogleBusinessProfileAppointmentLink(fn, req) {
        return fn(`/schedule/api/v2/google-business-profile-appointment-link?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
    UpdateGoogleBusinessProfileAppointmentLink(fn, req) {
        return fn(`/schedule/api/v2/google-business-profile-appointment-link`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * ------------------Insurance----------------------
     */
    CountInsuranceStatusByAppointments(fn, req) {
        return fn(`/schedule/api/v2/appointments/insurance/counts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
